import { FormEvent, useEffect, useState } from 'react';
import type {
  InternalCorrectionStatus,
  ModerationQueueFilters,
} from '../../lib/moderationApi';
import { buttonClass, inputClass } from './ModerationUi';

export const selectableQueueStatuses: Array<{
  value: InternalCorrectionStatus | '';
  label: string;
}> = [
  { value: '', label: 'Все статусы' },
  { value: 'SUBMITTED', label: 'Первое ревью' },
  { value: 'AWAITING_SECOND_REVIEW', label: 'Второе ревью' },
  { value: 'DISPUTED', label: 'Спорные' },
];

export function ModerationQueueFiltersForm({
  filters,
  onApply,
}: {
  filters: ModerationQueueFilters;
  onApply: (filters: ModerationQueueFilters) => void;
}): JSX.Element {
  const [draft, setDraft] = useState(filters);
  useEffect(() => setDraft(filters), [filters]);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    onApply(draft);
  };

  return (
    <form
      onSubmit={submit}
      className="grid gap-3 rounded-lg border border-border bg-card p-4 md:grid-cols-5"
    >
      <select
        aria-label="Статус"
        className={inputClass}
        value={draft.status}
        onChange={(event) =>
          setDraft((current) => ({
            ...current,
            status: event.target.value as InternalCorrectionStatus | '',
          }))
        }
      >
        {selectableQueueStatuses.map((status) => (
          <option key={status.value} value={status.value}>
            {status.label}
          </option>
        ))}
      </select>
      <input
        aria-label="Дата игры"
        className={inputClass}
        type="date"
        value={draft.gameDate}
        onChange={(event) =>
          setDraft((current) => ({ ...current, gameDate: event.target.value }))
        }
      />
      <input
        aria-label="Реплей"
        className={inputClass}
        placeholder="Реплей"
        value={draft.replay}
        onChange={(event) =>
          setDraft((current) => ({ ...current, replay: event.target.value }))
        }
      />
      <input
        aria-label="Отряд"
        className={inputClass}
        placeholder="Отряд автора фрага или жертвы"
        value={draft.squad}
        onChange={(event) =>
          setDraft((current) => ({ ...current, squad: event.target.value }))
        }
      />
      <button type="submit" className={buttonClass}>
        Применить
      </button>
    </form>
  );
}
